export default __webpack_public_path__ + "static/media/5 a.8198a50f.png";